export const CHAT_WIDGET_WIDTH = 350;

export const CHAT_WIDGET_MARGIN = 8;
